import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user.service';

@Component({
  selector: 'app-enhanced',
  templateUrl: './enhanced.component.html',
  styleUrls: ['./enhanced.component.scss']
})
export class EnhancedComponent implements OnInit {

  currentEnhancerNumber: string;
  currentEnhancerAllocation: string;

  newEnhancerNumber: string;
  newEnhancerAllocation: string;

  enhanced_statistic: any;
  enhancer_response: any;
  // enhancer_ten_year_increase: any;
  enhancer: any;
  constructor(public user: UserService) { }

  ngOnInit() {
    if (localStorage.getItem('current_enhanced_statistic') != undefined){
      this.user.getStatistic(localStorage.getItem('current_enhanced_statistic')).subscribe(statistic =>{
        this.enhanced_statistic = statistic;
      });
    }
    if (localStorage.getItem('current_enhancer') != undefined){
      this.user.getEnhancer(localStorage.getItem('current_enhancer')).subscribe(enhancer=>{
        this.enhancer = enhancer;
      });
    }
    this.user.currentEnhancerNumber.subscribe(currentEnhancerNumber => {
      this.currentEnhancerNumber = currentEnhancerNumber;
      this.newEnhancerNumber = currentEnhancerNumber;
    });
    this.user.currentEnhancerAllocation.subscribe(currentEnhancerAllocation => {
      this.currentEnhancerAllocation = currentEnhancerAllocation;
      this.newEnhancerAllocation = currentEnhancerAllocation;
    });
  }
  // editEnhancerAllocation(){
  //   this.user.editEnhancerAllocation(this.newEnhancerAllocation);
  //   this.user.enhancers.portfolio_percentage = Number(this.newEnhancerAllocation);
  //   for (let i of this.user.enhancers.ENHANCERS){
  //     i.portfolio_percentage = this.user.enhancers.portfolio_percentage * (i.percentage / 100.0);
  //   }
  //   this.user.enhancers.
  // }
  editEnhancerNumber(){
    this.user.editEnhancerNumber(this.newEnhancerNumber);
    // this.createYearArray();
    // this.editYearArray();
    this.editEnhancerArray();
  }
  round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }
  editEnhancerArray(){
    let newArray = {
      portfolio_percentage: Number(this.newEnhancerAllocation),
      percentage_total: 100,
      ENHANCERS: []
    }
    for (let i = 0; i < Number(this.newEnhancerNumber); i++){
      let newEnhancer = {
        enhancer_name: 'Enhancer ' + (i + 1),
        enhancer_id: (i + 1),
        percentage: this.round(100.0 / Number(this.newEnhancerNumber),2),
        portfolio_percentage: (100.0 / Number(this.newEnhancerNumber)) * (Number(this.newEnhancerAllocation) / 100.0 )
      }
      newArray.ENHANCERS[i] = newEnhancer;
    }
    this.user.enhancers = newArray;
  }
  editPercentage(enhancer){
    this.editPortfolioPercentage(enhancer);
    let new_percentage_total = 0;
    for (let i of this.user.enhancers.ENHANCERS){
      new_percentage_total += i.portfolio_percentage;
    }
    this.user.enhancers.percentage_total = new_percentage_total;


  }
  editPortfolioPercentage(enhancer){
    enhancer.portfolio_percentage = (Number(this.newEnhancerAllocation) / 100.0 ) * enhancer.percentage;
  }
  // This is good too now
  editIndividualEnhancerPercentage(enhancer){
    // first update the enhancer total (percentage total)
    enhancer.percentage = Number(enhancer.percentage);
    let enhancer_percentage = 0.0
    for (let i of this.user.enhancers.ENHANCERS){
      enhancer_percentage += i.percentage;
    }
    this.user.enhancers.percentage_total = enhancer_percentage; 
    // // Calculate portfolio percentage for the specific enhancer
    // enhancer.portfolio_percentage = (Number(this.newEnhancerAllocation) / 100.0 ) * enhancer.percentage;
    // // Recalculate the percentage total for all enhancers
    // let new_percentage_total = 0;
    // for (let i of this.user.enhancers.ENHANCERS){
    //   new_percentage_total += i.portfolio_percentage;
    // }
    // this.user.enhancers.percentage_total = new_percentage_total;

    // Recompute portfolio percentges of each enhancer
    let total_percentage = 0.0
    for (let i of this.user.enhancers.ENHANCERS){
      i.portfolio_percentage = (Number(this.newEnhancerAllocation) / 100.0 ) * i.percentage;
      total_percentage += i.portfolio_percentage;
    }
    // Update the portfolio percentage for all enhancers to equal the percentages total * enhancer allocation
    // this.user.enhancers.portfolio_percentage = this.user.enhancers.percentage_total * (Number(this.newEnhancerAllocation) / 100.0 );
    this.user.enhancers.portfolio_percentage = total_percentage;
  }
  // This is good
  editAllocationPercentage(){

    this.user.editEnhancerAllocation(this.newEnhancerAllocation);
    // Recompute portfolio percentges of each enhancer
    let total_percentage = 0.0
    for (let i of this.user.enhancers.ENHANCERS){
      i.portfolio_percentage = (Number(this.newEnhancerAllocation) / 100.0 ) * i.percentage;
      total_percentage += i.portfolio_percentage;
    }
    // Update the portfolio percentage for all enhancers to equal the percentages total * enhancer allocation
    // this.user.enhancers.portfolio_percentage = this.user.enhancers.percentage_total * (Number(this.newEnhancerAllocation) / 100.0 );
    this.user.enhancers.portfolio_percentage = total_percentage;
    // this.user.editAllocation(this.newEnhancerAllocation);
    
    // this.user.editEnhancerNumber(this.newEnhancerNumber);
  }
  computeOverallPortfolioPercentage(){
    // let total = 0.0;
    // for (let i of this.user.enhancers.ENHANCERS){
    //   total += i.portfolio_percentage;
    // }
    this.user.enhancers.portfolio_percentage = this.user.enhancers.percentage_total * (Number(this.newEnhancerAllocation) / 100.0 );
  }

  // Posting the enhancer
  addEnhancer(){
    let newEnhancer = {
      "allocation_id": localStorage.getItem('current_allocation'),
      "current_statistics_id": localStorage.getItem('current_have_statistic'),
      "enhancers": this.user.enhancers
    }
    // localStorage.getItem('current_allocation');
    // localStorage.getItem('current_have_statistic');
    this.user.addEnhancer(newEnhancer).subscribe(enhancer_response => {
      this.enhancer_response = enhancer_response;
      this.enhancer = this.enhancer_response.createdEnhancer;
      localStorage.removeItem('current_enhancer');
      localStorage.setItem('current_enhancer', this.enhancer_response.createdEnhancer._id);
      localStorage.removeItem('current_enhanced_statistic');
      localStorage.setItem('current_enhanced_statistic', this.enhancer_response.createdEnhancer.enhanced_statistics_id);
      this.user.getStatistic(this.enhancer_response.createdEnhancer.enhanced_statistics_id).subscribe(statistic =>{
        this.enhanced_statistic = statistic;
      });
      // // Added last line bc lazy and wanted to set the response to
      // this.enhancer_response = this.enhancer_response.createdEnhancer;
    });
  }
  clearEnhancer(){
    localStorage.removeItem('current_enhancer');
    localStorage.removeItem('current_enhanced_statistic');
    this.enhanced_statistic = {};
    this.enhancer = {};
    this.user.enhancers = {
      portfolio_percentage: 0,
      percentage_total: 0,
      ENHANCERS: [
        {
          enhancer_name: "Enhancer 1",
          enhancer_id: 1,
          percentage: 0,
          portfolio_percentage: 0
        }
      ]
    }
    // this.result.percentage = 0.0;
    // this.result.CATEGORIES.forEach( category => {
    //   category.category_percentage = 0.0;
    //   category.ASSETS.forEach( asset => {
    //       asset.asset_percentage = 0.0;
    //   });
    // });
  }

}
